module.exports = __webpack_public_path__ + "static/media/EncodeSansCondensed-Bold.97080e34.ttf";